import { reducer as campaigns, namespace as campaignsNamespace } from './campaignsCreation';
import { reducer as campaignsLists, namespace as campaignsListsNamespace } from './campaignsLists';
import { reducer as campaignsEdit, namespace as campaignsEditNamespace } from './campaignsEdit';
import { reducer as campaignsDetails, namespace as campaignsDetailsNamespace } from './campaignsDetails';
import { reducer as discountsLists, namespace as discountsListsNamespace } from './discountsLists';
import { reducer as discountsEdit, namespace as discountsEditNamespace } from './discountsEdit';

export interface State {
    [campaignsNamespace]: campaigns.State;
    [campaignsListsNamespace]: campaignsLists.State;
    [campaignsEditNamespace]: campaignsEdit.State;
    [campaignsDetailsNamespace]: campaignsDetails.State;
    [discountsListsNamespace]: discountsLists.State;
    [discountsEditNamespace]: discountsEdit.State;
}

export const initialState: State = {
    [campaignsNamespace]: campaigns.initialState,
    [campaignsListsNamespace]: campaignsLists.initialState,
    [campaignsEditNamespace]: campaignsEdit.initialState,
    [campaignsDetailsNamespace]: campaignsDetails.initialState,
    [discountsListsNamespace]: discountsLists.initialState,
    [discountsEditNamespace]: discountsEdit.initialState,
};

export const reducers = {
    [campaignsNamespace]: campaigns.reducer,
    [campaignsListsNamespace]: campaignsLists.reducer,
    [campaignsEditNamespace]: campaignsEdit.reducer,
    [campaignsDetailsNamespace]: campaignsDetails.reducer,
    [discountsListsNamespace]: discountsLists.reducer,
    [discountsEditNamespace]: discountsEdit.reducer,
};
